"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BOILogo = require("./BOILogo");

var _BOILogo2 = _interopRequireDefault(_BOILogo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _BOILogo2.default;